import { getChangedFields } from '@/services/audit/getChangedFields';
import {
  logCreate,
  logRoleChange,
  logStatusChange,
  logUpdate,
} from '@/services/audit/audit.service';
import { sanitizeSnapshot } from '@/services/audit/sanitizeSnapshot';
import type { AuditEntityType } from '@/types/audit';

type RecordEntityWriteParams = {
  entityType: AuditEntityType;
  entityId: string;
  isCreate: boolean;
  before?: Record<string, unknown> | undefined;
  after: Record<string, unknown>;
  metadata?: Record<string, unknown> | undefined;
};

/** Registra auditoría tras persistencia exitosa (no lanza si falla el log). */
export function recordEntityWrite(params: RecordEntityWriteParams): void {
  const after = sanitizeSnapshot(params.after) ?? {};
  const before = params.before
    ? (sanitizeSnapshot(params.before) ?? {})
    : undefined;

  if (params.isCreate) {
    void logCreate({
      entityType: params.entityType,
      entityId: params.entityId,
      after,
      ...(params.metadata !== undefined ? { metadata: params.metadata } : {}),
    });
    return;
  }

  if (!before) {
    void logUpdate({
      entityType: params.entityType,
      entityId: params.entityId,
      after,
      ...(params.metadata !== undefined ? { metadata: params.metadata } : {}),
    });
    return;
  }

  const changedFields = getChangedFields(before, after);

  if (
    params.entityType === 'user' &&
    changedFields.includes('role')
  ) {
    void logRoleChange({
      entityType: params.entityType,
      entityId: params.entityId,
      before,
      after,
      changedFields,
      ...(params.metadata !== undefined ? { metadata: params.metadata } : {}),
    });
    return;
  }

  if (changedFields.includes('status')) {
    void logStatusChange({
      entityType: params.entityType,
      entityId: params.entityId,
      before,
      after,
      changedFields,
      ...(params.metadata !== undefined ? { metadata: params.metadata } : {}),
    });
    return;
  }

  if (changedFields.length === 0) {
    return;
  }

  void logUpdate({
    entityType: params.entityType,
    entityId: params.entityId,
    before,
    after,
    changedFields,
    ...(params.metadata !== undefined ? { metadata: params.metadata } : {}),
  });
}
